import { APP_ID_PRISMA_ACCESS, APP_ID_PRISMA_ACCESS_EDITION } from './components/common/GlobalConstants'

export { TSG_NONE, LG_BASE_FONT_SIZE } from '../common/constants/GlobalConstants'
export const PLATFORM_APP_ID = 'platform'
export const DISCLAIMER = 'Palo Alto Networks, Inc. All rights reserved.'
export const ACTIVATION_ERROR_SCREEN_TITLE = 'Activation Error'
// export const ACTIVATION_ERROR_HELP_TEXT = 'An error occured while decoding the hash. Please check the URL and try again. If the error persists then contact support.'
export const ACTIVATION_ERROR_NO_MANIFEST_HELP_TEXT = 'An error occured during activation. Please check the URL and try again. If the error persists then contact support.'
export const PLATFORM_REGION_MISMATCH_WARNING_MESSAGE = 'Your {app_display} instance is located in the {region_display} region and you have selected the {platform_region_display} region for your Strata Logging Service. {app_display} will use data from the Strata Logging Service to render additional insights.'
export const LICENSE_QUANTITY_TITLE = 'License Quantity'
export const LICENSE_EXPIRY_TITLE = 'Expires'
export const AIOPS_APP_ID = 'strata_insights'
export const IOT_APP_ID = 'zingbox'
export const IOT_3P_ADDON_APP_ID = 'zingbox_3p_addon'
export const AIOPS_APP_ID_FREE = 'strata_insights_free'
export const APP_ID_IOT = 'zingbox'
export const IOT_HASH_CONTEXT = 'iot'
export const APP_ID_SAASINLINE = 'aperture'

export const SEB_APP_ID = 'seb'
export const SCM_APP_ID = 'strata_cloud_manager'
export const CIE_APP_ID = 'directory_sync'
export const SEB_HASH_CONTEXT = 'seb'

export const PRISMA_ACCESS_HASH_CONTEXT = 'prisma_access'


export const BACKBONE_APP_ID = 'mssp_backbone'
export const CONTEXT_TO_APP_ID = {
  'aiops': AIOPS_APP_ID,
  'backbone': BACKBONE_APP_ID,
  'aiops-free': AIOPS_APP_ID_FREE,
  'scm-base': SCM_APP_ID,
  'directory_sync': CIE_APP_ID,
  [IOT_HASH_CONTEXT]: IOT_APP_ID,
  [APP_ID_PRISMA_ACCESS]: APP_ID_PRISMA_ACCESS_EDITION,
}
export const ACTION_BUTTON_LABEL = 'Actions'
export const ACTION_BUTTON_DAS = 'Device Associations'
export const ACTION_BUTTON_CLOUD = 'Activate Cloud Tenant'
export const ACTION_BUTTON_NOOP = 'No action available'
export const SUPER_ROOT_ID = '_superRoot'
export const VALIDATION_SUCCESS = 'Validation Success'
export const VALIDATION_FAILED = 'Validation Failed'
export const APP_SUBDOMAIN = 'App Subdomain'
export const URL_VALIDATIONS = ['zingbox']
export const URL_VALIDATIONS_REGEX = {
  [APP_ID_IOT]: /^((?!-)[a-zA-Z0-9-]{0,63}[a-zA-Z0-9])$/,
}
export const IOT_PACKAGE_1 = '1.0'
export const IOT_PACKAGE_2 = '2.0'

export const DAS_BANNER_MESSAGE = 'When activation is finished, please choose firewalls from Device Associations tab.'
export const CDL_MIGRATION_TITLE = 'SLS Migration:'
export const CDL_MIGRATION_MESSAGE = 'Please note that the SLS app will now be accessible on hub 2.0 (dark mode) or under “view by tenants”'
export const CDL_MIGRATION_NO_INSTANCE = 'No SLS available to migrate'

export { GOV_REGION as FED_MOD_REGION } from '../common/constants/GlobalConstants'
export const FED_HIGH_REGION = 'fed'
export const CHINA_REGION = 'cn'

export const CSP_LEARN_MORE_LINK = 'https://docs.paloaltonetworks.com/common-services/subscription-and-tenant-management/cloud-managed-prisma-access-and-add-ons-license-activation/activate-a-license-for-cloud-managed-prisma-access-and-add-ons'
export const ACCORDION_COMPLETE_EVENT_KEY = 'activation-accordion-complete'

export const DEVICE_ASSOCIATIONS_URL = 'https://stratacloudmanager.paloaltonetworks.com/settings/devices'
export const DEVICE_ASSOCIATIONS_TEXT = 'Device Associations'
export const CDL_DEVICE_ASSOCIATIONS_MESSAGE = 'Strata Logging Service will be associated with all devices on this tenant.'
export const DEVICE_ASSOCIATIONS_LINK_FOLLOW_MESSAGE = 'to view devices on this tenant.'
